export default __webpack_public_path__ + "static/404-28bfdbf87eceb8252ad916ee30fdf2b5.png";